import $ from "jquery";
import MobileDetect from '../js/mobile';
import 'jquery.appear';

window.$ = window.jQuery = $;

class InnerPage {

    Init = () => {
        const self = this;
        if($('.ourf').length){
            self.OurFacilitiesInit();
        }
    };
    OurFacilitiesInit = () => {
        let re = /([\-\.\d]+)/gi;
        $('.ourf__map .cls-1,.ourf__map .sign').bind('mouseenter', function(e) {
            $('.ourfpopup').removeClass('revers');

            let name = $(this).data('name');
            $('.ourf__map .cls-1').removeClass('hover');

            $('.ourf__map .cls-1[data-name="'+name+'"],.ourf__map .sign[data-name="'+name+'"]').addClass('hover');

            $('.ourfpopup').hide();
            $('.ourfpopup.'+name).show();

            console.log($('.ourfpopup.'+name).offset().top, $(window).scrollTop())

            if($(window).width()>1000){
                if($('.ourfpopup.'+name).offset().top < $(window).scrollTop()){
                    $('.ourfpopup.'+name).addClass('revers');
                }else{
                    $('.ourfpopup.'+name).removeClass('revers');
                }

            }
        });
        $('.ourf__map .cls-1').bind('mouseleave', function(e) {
            let name = $(this).data('name');
        });
        $('.ourf__map').bind('mouseleave', function(e) {
            $('.ourfpopup').hide();
            $('.ourf__map .cls-1').removeClass('hover');
        });


        if($(window).width()<=1000) {
            $('.ourf__maplayer').bind('click', function(e) {
                let t = $(e.target);
                if (t.closest('.cls-1').length === 0 && t.closest('.sign').length === 0) {
                    $('.ourfpopup').hide();
                    $('.ourf__map .cls-1').removeClass('hover');
                }
            });
        }

        $('.ourfpopup-close').bind('click', function() {
            $('.ourfpopup').hide();
            $('.ourf__map .cls-1').removeClass('hover');
        });





        $('.ourf__map .cls-2,.ourf__map .cls-3,.ourf__map .cls-4,.ourf__map svg').bind('mouseenter', function(e) {
           // $('.ourfpopup').hide();
           // $('.ourf__map .cls-1').removeClass('hover');
        });

        /*
        setTimeout(function () {
          $('.ourf__content').addClass('active');
          setTimeout(function () {
              $('.ourf__leaf div,.ourf__leaf1 div,.ourf__leaf2 div,.ourf__leaf3 div').addClass('anim');
          },1800);
        }, 2000);

         */

        $('.ourf__content').addClass('active');
        $('.ourf__leaf div,.ourf__leaf1 div,.ourf__leaf2 div,.ourf__leaf3 div').addClass('anim');
    };
}


export default new InnerPage;
